<template>
  <div
    v-if="favoris?.length"
    class="sidebar__quick-access"
  >
    <BasicText
      v-if="!reduced"
      weight="bold"
      color="secondary-800"
      class="sidebar__quick-access--label"
    >
      Accès rapides
    </BasicText>
    <div class="sidebar__quick-access-items">
      <div
        v-for="(item, index) in favoris"
        :key="index"
        class="sidebar__quick-access-item"
      >
        <div
          class="sidebar__quick-access-item-chip"
          :class="`color-recherche-${item.type}`"
          @click="$emit('navigateToFavori', item.key)"
          :title="item.name"
        />
        <div
          v-if="!reduced"
          class="sidebar__quick-access-item--action"
        >
          <BasicLink
            :label="item.name"
            type="dark"
            @link-click="$emit('navigateToFavori', item.key)"
            class="sidebar__quick-access-item--action-link"
            wrapLink
            nb-max-lines="2"
          />
          <BasicIcon
            name="close"
            focusable
            color="secondary-800"
            @click="$emit('deleteFavorite', item.key)"
            pointer
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  type Favori = {
    key: string
    name: string
    type: string
  }

  interface SidebarQuickAccessProps {
    reduced?: boolean
    favoris?: Favori[]
  }

  withDefaults(defineProps<SidebarQuickAccessProps>(), {
    reduced: false,
    favoris: () => [],
  })
</script>

<style lang="less">
  @import 'SidebarQuickAccess.less';
</style>
